import { router, useLocalSearchParams } from 'expo-router';
import * as WebBrowser from 'expo-web-browser';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { useOnBoarding } from '@/api/hooks/meHooks';
import BrandedButton from '@/components/buttons/BrandedButton';
import Text from '@/components/Text';
import { PRIVACY_POLICY_URL, TERMS_OF_USE_URL } from '@/constants/config';
import { SIGN_IN_BUTTON_BOTTOM } from '@/constants/layout';
import { useColor } from '@/hooks/useColor';
import { i18n } from '@/utils/i18n';

const EulaScreen = () => {
  const colors = useColor();
  const { onBoardingId, buyingShow } = useLocalSearchParams<{ onBoardingId: string; buyingShow: string }>();
  const { mutateAsync: onBoardingUpdate, isPending } = useOnBoarding();

  const title = i18n.t('sign_in.eula.title');
  const buttonText = i18n.t('mix.next');
  const firstTerms = i18n.t('sign_in.eula.first_terms');
  const termsLink = i18n.t('mix.terms');
  const andText = i18n.t('mix.and');
  const privacyLink = i18n.t('mix.privacy');

  const onPress = () => {
    onBoardingUpdate(
      { agreeEULA: true, onBoardingId: onBoardingId },
      {
        onSuccess: () => {
          router.replace({ pathname: '/login/notifications', params: { from: 'individual', buyingShow } });
        }
      }
    );
  };

  const openURL = async (type: string) => {
    let url = type === 'tos' ? TERMS_OF_USE_URL : PRIVACY_POLICY_URL;
    WebBrowser.openBrowserAsync(url);
  };

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.contentWrapper}>
        <Text style={[styles.titleText, { color: colors.titleText }]} fontWeight="700">
          {title}
        </Text>
        <Text>
          {firstTerms}{' '}
          <Text fontWeight="700" onPress={() => openURL('tos')} style={[styles.linkText, { color: colors.linkText }]}>
            {termsLink}{' '}
          </Text>
          {andText}{' '}
          <Text fontWeight="700" onPress={() => openURL('pp')} style={[styles.linkText, { color: colors.linkText }]}>
            {privacyLink}
          </Text>
        </Text>
      </View>
      <BrandedButton loading={isPending} style={styles.btnStyle} onPress={onPress}>
        {buttonText}
      </BrandedButton>
    </SafeAreaView>
  );
};

export default EulaScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginHorizontal: 16
  },
  contentWrapper: {
    flex: 1
  },
  titleText: {
    fontSize: 22,
    marginBottom: 26,
    textAlign: 'center',
    marginTop: 142
  },

  btnStyle: {
    marginBottom: SIGN_IN_BUTTON_BOTTOM,
    width: '100%'
  },

  linkText: {
    fontSize: 14
  }
});
